
  import { defineComponent, PropType } from 'vue';

  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';

  import Api from '../api';
  import type { TPresentationForm, TPresentationOption } from '../types/presentation';
  import PresentationMainForm from './PresentationMainForm.vue';

  type TMultiPageForm = Pick<TPresentationForm, 'countryId' | 'year' | 'isExportPotential' | 'isImportPotential'>;

  export default defineComponent({
    name: 'PresentationMultiPageForm',
    components: { PresentationMainForm, CheckboxInput },
    props: {
      countries: {
        type: Array as PropType<TPresentationOption[]>,
        default: () => [],
      },
      defaultCountryId: {
        type: [Number, String] as PropType<Nullable<number | string>>,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['success', 'loading'],
    data(): { form: TMultiPageForm; isLoading: boolean } {
      return {
        form: {
          countryId: this.defaultCountryId,
          year: null,
          isExportPotential: false,
          isImportPotential: false,
        },
        isLoading: false,
      };
    },
    methods: {
      async onDownload() {
        this.setLoading(true);
        try {
          await Api.createMuiltyPagePresentation(this.form);
          this.$emit('success');
        } catch {
          Constants.alert.fire(Constants.errorTitle, Constants.commonError, 'error');
        } finally {
          this.setLoading(false);
        }
      },
      setLoading(value: boolean) {
        this.isLoading = value;
        this.$emit('loading', value);
      },
    },
  });
